(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-banner-lola]').forEach(function (section) {
    initResponsiveMedia(section);

    // Reduced motion: text stays fully visible and static (handled by
    // the CSS override), so there's nothing for this scroll listener to
    // drive — skip it entirely.
    if (prefersReducedMotion) return;

    var ticking = false;

    function update() {
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      // Progress goes from 0 (section's top just entering at the very
      // bottom of the viewport) to 1 (section's top has scrolled up to
      // 20% from the top of the viewport) — a wider window than before,
      // so the effect plays out gradually over more scroll distance
      // instead of completing almost immediately.
      var start = viewportHeight;
      var end = viewportHeight * 0.2;
      var progress = (start - rect.top) / (start - end);

      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      section.style.setProperty('--banner-lola-reveal', progress.toFixed(3));
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });

  // Same lazy-loading pattern as heromain-lola/video-lola: all four
  // combinations (desktop/mobile × day/night) sit inertly inside
  // <template> tags — content inside a <template> is never parsed as
  // live DOM and its image is never fetched by the browser, unlike a
  // hidden element (display: none can still download in some browsers).
  // This checks the current viewport width AND the current theme BEFORE
  // any of the four is ever inserted, and only clones/inserts the one
  // that actually matches — so only one image ever downloads, regardless
  // of screen size or theme. A MutationObserver reacts live if the
  // visitor toggles day/night without a page reload.
  function initResponsiveMedia(section) {
    var mediaContainer = section.querySelector('[data-banner-lola-media]');
    if (!mediaContainer) return;

    var templates = {
      desktop: {
        day: section.querySelector('template[data-banner-lola-media="desktop"][data-banner-lola-theme="day"]'),
        night: section.querySelector('template[data-banner-lola-media="desktop"][data-banner-lola-theme="night"]')
      },
      mobile: {
        day: section.querySelector('template[data-banner-lola-media="mobile"][data-banner-lola-theme="day"]'),
        night: section.querySelector('template[data-banner-lola-media="mobile"][data-banner-lola-theme="night"]')
      }
    };

    // Nothing to show at all — no desktop day template means the
    // merchant never uploaded a background image in the first place.
    if (!templates.desktop.day) return;

    var breakpoint = window.matchMedia('(min-width: 750px)');
    var liveEl = null;
    var lastKey = null;

    function currentTheme() {
      return document.documentElement.getAttribute('data-theme') === 'night' ? 'night' : 'day';
    }

    // Fallback chain: night falls back to day at the SAME width first
    // (e.g. a merchant who only set a mobile day image, no mobile
    // night, still gets their mobile day image at night rather than
    // jumping straight to the desktop image); only falls back to
    // desktop when that specific width has no template configured at
    // all (e.g. no mobile override and no slider toggle).
    function resolveTemplate(widthKey, themeKey) {
      var group = templates[widthKey];
      var picked = themeKey === 'night' ? (group.night || group.day) : group.day;
      if (picked) return picked;

      var desktopGroup = templates.desktop;
      return themeKey === 'night' ? (desktopGroup.night || desktopGroup.day) : desktopGroup.day;
    }

    function insertWinner() {
      var widthKey = breakpoint.matches ? 'desktop' : 'mobile';
      var themeKey = currentTheme();
      var key = widthKey + '-' + themeKey;

      // Nothing to do if the correct combination is already live.
      if (key === lastKey) return;

      var winningTemplate = resolveTemplate(widthKey, themeKey);
      if (!winningTemplate) return;

      if (liveEl) {
        liveEl.remove();
      }

      // Cloning the <template>'s content is what actually triggers the
      // browser to start fetching the image for the FIRST time — until
      // this exact moment, none of the possible assets have downloaded
      // anything at all, regardless of which one ends up winning.
      var fragment = winningTemplate.content.cloneNode(true);
      var wrapper = document.createElement('div');
      wrapper.style.display = 'contents';
      wrapper.appendChild(fragment);

      // Inserted right before the templates themselves, so it stays
      // beneath the overlay (a later sibling) in paint order, and
      // establishes the section's real height via normal document flow
      // exactly like the original inline image did.
      mediaContainer.insertBefore(wrapper, templates.desktop.day);
      liveEl = wrapper;
      lastKey = key;
    }

    breakpoint.addEventListener('change', insertWinner);

    // header-lola's theme toggle sets data-theme directly on <html> —
    // no custom event is dispatched anywhere for that change, so a
    // MutationObserver is the reliable way to react to it live,
    // regardless of which section/script actually triggered the switch.
    var themeObserver = new MutationObserver(insertWinner);
    themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    insertWinner();
  }
})();